// removed by extract-text-webpack-plugin
module.exports = {"header":"header__header___EJ2yr","container":"header__container___2C5RE","wrapper":"header__wrapper___eU4Ha","home":"header__home___2wVB7","logo":"header__logo___1mGlg","navigationWrapper":"header__navigationWrapper___1j2HI","toggle":"header__toggle___2fIOG","bar":"header__bar___34WTD","languages":"header__languages___23dwq","navigation":"header__navigation___1ja7-","navigationAction":"header__navigationAction___q1WxP","navLink":"header__navLink___3x27m","fadein":"header__fadein___3ekGg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/header/header.scss
// module id = 278
// module chunks = 0